<template>
  <VerticalContainer>
    <AssetsTable
      v-if="hasLabelParam"
      is-select-asset
      :selected-id="selectedAsset.id"
      :is-disabled="isLoading"
      @clickRow="selectAsset"
    />
    <ErrorMessage :error-message="errorMessage" />
    <template #buttons>
      <Button
        :on-click="addLabelToAssetClick"
        text="Add label to asset"
        :is-loading="isLoading"
      />
      <Button
        text="Cancel"
        :on-click="cancel"
        :disabled="isLoading"
      />
    </template>
    <YesNoDialogue
      :is-visible="isDialogueVisible"
      :message="yesNoMessage"
      @no="() => isDialogueVisible = false"
      @yes="addLabelToAsset"
    />
  </VerticalContainer>
</template>
<script>
import VerticalContainer from '../../components/organisms/layout/vertical-container';
import Button from '../../components/atoms/button/button';
import ErrorMessage from '../../components/atoms/message/error-message';
import YesNoDialogue from '../../components/molecules/dialogues/yes-no-dialogue';
import AssetsTable from '../../components/organisms/assets/assets-table';
import { routeNames } from '../../constants';

export default {
  name: 'SelectAsset',
  components: {
    VerticalContainer,
    Button,
    ErrorMessage,
    YesNoDialogue,
    AssetsTable,
  },
  props: {
    label: { type: Object, default: null },
  },
  data() {
    return {
      selectedAsset: { id: null },
      clientErrorMessage: '',
      isDialogueVisible: false,
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.assets.isLoadingAsset;
    },
    yesNoMessage() {
      return "This asset already has a linked label. If you select 'yes', the original label will be replaced.";
    },
    serverErrorMessage() {
      return this.$store.state.assets.errorMessage;
    },
    errorMessage() {
      return [this.clientErrorMessage, this.serverErrorMessage]
        .filter((message) => message && message !== '')
        .join(', ');
    },
    hasError() {
      return this.errorMessage !== '';
    },
    hasLabelParam() {
      return this.label !== null;
    },
  },
  created() {
    if (!this.hasLabelParam) {
      this.cancel();
    }
  },
  destroyed() {
    this.$store.commit('assets/CLEAR_ERROR_MESSAGE');
  },
  methods: {
    cancel() {
      this.goToAssetsHome();
    },
    selectAsset(asset) {
      this.clientErrorMessage = '';
      this.$store.commit('assets/CLEAR_ERROR_MESSAGE');
      if (asset.isSelected) {
        this.selectedAsset = { id: null };
      } else {
        this.selectedAsset = asset;
      }
    },
    addLabelToAssetClick() {
      if (this.selectedAsset.id === null) {
        this.clientErrorMessage = 'Please select an asset';
      } else if (this.selectedAsset.hasLabel) {
        this.isDialogueVisible = true;
      } else {
        this.addLabelToAsset();
      }
    },
    async addLabelToAsset() {
      this.isDialogueVisible = false;
      await this.$store.dispatch('assets/addLabelToAsset', {
        id: this.selectedAsset.id,
        label: this.label,
      });
      if (!this.hasError) {
        this.goToAssetsHome();
        const asset = this.$store.state.assets.assets.filter(
          ({ id }) => this.selectedAsset.id === id,
        )[0];
        this.$root.trackEvent.linkedLabel(asset, false);
      }
    },
    goToAssetsHome() {
      this.$router.replace({ name: routeNames.assets.list });
    },
  },
};
</script>
